import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import useTheme from "@material-ui/core/styles/useTheme";
import { Box, createStyles } from "@material-ui/core";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import NavigationDrawer from "../shared/NavigationDrawer";
import { Route } from "react-router";
import {
  ACCOUNT_DEFINITION,
  ACTIVE_ACCOUNT,
  EXERCISE_RESERVATION,
  FINALIZE_PAGE,
  FINALIZE_SUCCESS,
  KRYTY_PAGE,
  MY_ACCOUNT,
  SEAT_SALE,
  STRZELNICA_PAGE,
} from "./routes";
import MyAccount from "../components/MyAccount";
import ExerciseSale from "../components/ExerciseSale";
import ActiveAccount from "../components/ActiveAccount";
import FinalizePage from "../components/FinalizePage";
import FinalizeSuccess from "../components/FinalizePage/FinalizeSuccess";
import SeatSale from "../components/SeatSale";
import Header from "../shared/Header";
import useUrlApi from "../api/useUrlApi";
import MainPage from "../components/MainPage";
import AccountDefinition from "../components/AccountDefinition";
import StrzelnicaPage from "../components/MainPage/strzelincaPage";
import KrytyPage from "../components/MainPage/krytyPage";

// @ts-ignore
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    background: {
      minHeight: "100vh",
      paddingTop: (isDesktop: boolean) => (isDesktop ? "0" : "13vh"),
      paddingBottom: "2%",
      width: (isDesktop: boolean) => (isDesktop ? "100%" : "100%"),
      margin: "0 auto",
      overflowX: "hidden",
    },
    backgroundContainer: {
      backgroundColor: theme.palette.background.default,
      display: "flex",
      width: "100%",
    },
  })
);

const Routing: React.FC = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));
  const classes = useStyles(isDesktop);
  useUrlApi();

  return (
    <Box className={classes.backgroundContainer}>
      <NavigationDrawer />
      <Box className={classes.background}>
        <Header />
        <Route path={"/"} component={MainPage} />
        <Route path={ACTIVE_ACCOUNT} component={ActiveAccount} />
        <Route path={MY_ACCOUNT} component={MyAccount} />
        <Route path={EXERCISE_RESERVATION} component={ExerciseSale} />
        <Route path={FINALIZE_SUCCESS} component={FinalizeSuccess} />
        <Route path={SEAT_SALE} component={SeatSale} />
        <Route path={ACCOUNT_DEFINITION} component={AccountDefinition} />
        <Route path={FINALIZE_PAGE} render={() => <FinalizePage action={"pay"} />} />

        <Route path={STRZELNICA_PAGE} render={() => <StrzelnicaPage />} />
        <Route path={KRYTY_PAGE} render={() => <KrytyPage />} />
      </Box>
    </Box>
  );
};

export default Routing;
